package fr.frux.feature.site.create

/** Position choisie sur la carte pour le nouveau lieu. */
data class CreateSiteArgs(
    val latitude: Double,
    val longitude: Double,
)
